import React, { useState } from "react";
import { useTransition, animated } from "react-spring";
import ProgressBar from "../../ProgressBar";
import { stepStyles } from "../formStyles";

export const PrimaryBorrower = ({ formData, setForm, navigation }) => {
  const [error, setError] = useState(false);
  const [isVisible] = useState(true);

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(500px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  const checkForNextStep = () => {
    if (formData.primaryBorrowerFirstName === "" && formData.primaryBorrowerLastName === "") {
      setError(true);
      console.log("error");
    }
    if (formData.primaryBorrowerFirstName !== "" && formData.primaryBorrowerLastName !== "") {
      navigation.next();
      console.log("next");
    }
  };
  return (
    <div className={stepStyles.page}>
      <ProgressBar width={"95%"} />
      <div className={stepStyles.content}>
        {transition((style, item) =>
          item ? (
            <animated.div style={style} className={stepStyles.panel}>
              <h1 className={stepStyles.title}>Who will be the primary borrower on the loan?</h1>
              <div className={stepStyles.fieldStack}>
                <div className={stepStyles.fieldRow}>
                  <div className="w-full md:w-auto">
                    <input
                      name="primaryBorrowerFirstName"
                      value={formData.primaryBorrowerFirstName}
                      onChange={setForm}
                      id="primaryBorrowerFirstName"
                      className={stepStyles.input}
                      placeholder="First Name"
                    />
                  </div>
                  <label className={stepStyles.fieldLabel}>First Name</label>
                </div>
                <div className={stepStyles.fieldRow}>
                  <div className="w-full md:w-auto">
                    <input
                      name="primaryBorrowerLastName"
                      value={formData.primaryBorrowerLastName}
                      onChange={setForm}
                      id="primaryBorrowerLastName"
                      className={stepStyles.input}
                      placeholder="Last Name"
                    />
                  </div>
                  <label className={stepStyles.fieldLabel}>Last Name</label>
                </div>
                {error ? <p className={stepStyles.error}>please fill out an answer</p> : null}
              </div>
            </animated.div>
          ) : null,
        )}
      </div>
      <div className={stepStyles.actionBar}>
        <div className={stepStyles.actionRow}>
          <div className="w-full md:w-auto">
            <button className={`${stepStyles.button} w-full`} onClick={() => checkForNextStep()}>
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
